var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfExel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 64,
    height: 64,
    rx: 12,
    transform: "rotate(180 64 64)",
    fill: "#C5EEDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 30.3334C22 25.6193 22 23.2623 23.4645 21.7978C24.9289 20.3334 27.286 20.3334 32 20.3334H37C41.714 20.3334 44.0711 20.3334 45.5355 21.7978C47 23.2623 47 25.6193 47 30.3334V38.6667C47 43.3808 47 45.7378 45.5355 47.2022C44.0711 48.6667 41.714 48.6667 37 48.6667H32C27.286 48.6667 24.9289 48.6667 23.4645 47.2022C22 45.7378 22 43.3808 22 38.6667V30.3334Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8334 29.5C42.8334 30.2766 42.8334 30.6649 42.7065 30.9711C42.5373 31.3795 42.2129 31.704 41.8045 31.8731C41.4982 32 41.1099 32 40.3334 32H28.6667C27.8901 32 27.5019 32 27.1956 31.8731C26.7872 31.704 26.4627 31.3795 26.2936 30.9711C26.1667 30.6649 26.1667 30.2766 26.1667 29.5C26.1667 28.7234 26.1667 28.3351 26.2936 28.0289C26.4627 27.6205 26.7872 27.296 27.1956 27.1269C27.5019 27 27.8901 27 28.6667 27L40.3334 27C41.1099 27 41.4982 27 41.8045 27.1269C42.2129 27.296 42.5373 27.6205 42.7065 28.0289C42.8334 28.3351 42.8334 28.7234 42.8334 29.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8334 34.5C42.8334 35.2766 42.8334 35.6649 42.7065 35.9711C42.5373 36.3795 42.2129 36.704 41.8045 36.8731C41.4982 37 41.1099 37 40.3334 37H28.6667C27.8901 37 27.5019 37 27.1956 36.8731C26.7872 36.704 26.4627 36.3795 26.2936 35.9711C26.1667 35.6649 26.1667 35.2766 26.1667 34.5C26.1667 33.7234 26.1667 33.3351 26.2936 33.0289C26.4627 32.6205 26.7872 32.296 27.1956 32.1269C27.5019 32 27.8901 32 28.6667 32H40.3334C41.1099 32 41.4982 32 41.8045 32.1269C42.2129 32.296 42.5373 32.6205 42.7065 33.0289C42.8334 33.3351 42.8334 33.7234 42.8334 34.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8334 39.5C42.8334 40.2766 42.8334 40.6649 42.7065 40.9711C42.5373 41.3795 42.2129 41.704 41.8045 41.8731C41.4982 42 41.1099 42 40.3334 42H28.6667C27.8901 42 27.5019 42 27.1956 41.8731C26.7872 41.704 26.4627 41.3795 26.2936 40.9711C26.1667 40.6649 26.1667 40.2766 26.1667 39.5C26.1667 38.7234 26.1667 38.3351 26.2936 38.0289C26.4627 37.6205 26.7872 37.296 27.1956 37.1269C27.5019 37 27.8901 37 28.6667 37H40.3334C41.1099 37 41.4982 37 41.8045 37.1269C42.2129 37.296 42.5373 37.6205 42.7065 38.0289C42.8334 38.3351 42.8334 38.7234 42.8334 39.5Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 43.6667C19.2386 43.6667 17 41.4281 17 38.6667V28.6667C17 22.3813 17 19.2386 18.9526 17.286C20.9052 15.3334 24.0479 15.3334 30.3333 15.3334H37C39.7614 15.3334 42 17.572 42 20.3334",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfExel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-exel.f4b1d494d986dcbef2ae17132a78fb99.svg";